{
  "Device_Filter_SectionHeader": "Device Type Filtering",
  "Device_Filter_Dropdown_Label": "Device Type",
  "NAME": "ReportsFilterDeviceFilter"
}